import React from "react";

export default function CallForPapers() {
  return (
    <div>
      <hr className="top-margin" />
      {/* <!--/NAVBAR--> */}

      {/* <!--BODY--> */}
      <br />
      <div className="container mt-3" style={{ textAlign: "justify" }}>
        <h5>
          Authors are invited to contribute to the conference by submitting
          novel unpublished articles in the following areas but not restricted
          to:
        </h5>
      </div>

      <div className="content" style={{ marginBottom: "5rem" }}>
        <div className="about">
          <div
            className="card border-primary mb-3"
            style={{ width: "auto", height: "100%" }}
          >
            <div className="card-body">
              <h5 className="card-title text-primary ">
                TRACK 1: COMMUNICATION TECHNOLOGIES
              </h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div className="container">
                <ol style={{ listStyle: "disc" }}>
                  <li> Antenna Design and RF Propagation</li>
                  <li> Microwaves Circuits Design</li>
                  <li> Optical Communication and Components</li>
                  <li> Communication Theory and Information Theory</li>
                  <li> Broad Band Communication</li>
                  <li> Satellite Communication</li>
                  <li> Computer and Intelligent Communication</li>
                  <li> MEMS and Sensors Design</li>
                  <li> Electronic System Level Design</li>
                  <li> Embedded Wireless Systems</li>
                  <li> Channel modeling & simulation</li>
                  <li> Channel coding, modulation, multiplexing</li>
                  <li> MISO and MIMO processing</li>
                  <li> RF Communication </li>
                  <li> Fiber Optic Communication System </li>
                  <li> Wireless and Mobile Communication </li>
                  <li> Image and Video Signal Processing </li>
                  <li> Speech & Signal Processing</li>
                  <li> Adaptive Signal Processing</li>
                  <li> Nano Electronics </li>
                  <li> Low Power Electronics</li>
                  <li> Robotics and Automation</li>
                  <li> VLSI for DSP</li>
                  <li> Nano-Fabrication & Computing</li>
                  <li> Semiconductor Technology</li>
                  <li> Filters and Data Conversion Circuits</li>
                  <li> Analog & Digital Circuits</li>
                  <li> Mixed Signal Circuits</li>
                  <li> ASIC & SOC</li>
                  <li> CAD forAntenna Design and RF Propagation</li>
                  <li> Microwaves Circuits Design</li>
                  <li> Optical Communication and Components</li>
                  <li> Communication Theory and Information Theory</li>
                  <li> Broad Band Communication</li>
                  <li> Satellite Communication</li>
                  <li> Computer and Intelligent Communication</li>
                  <li> MEMS and Sensors Design</li>
                  <li> Electronic System Level Design</li>
                  <li> Embedded Wireless Systems</li>
                  <li> Channel modeling & simulation</li>
                  <li> Channel coding, modulation, multiplexing</li>
                  <li> MISO and MIMO processing</li>
                  <li> RF Communication </li>
                  <li> Fiber Optic Communication System </li>
                  <li> Wireless and Mobile Communication </li>
                  <li> Image and Video Signal Processing </li>
                  <li> Speech & Signal Processing</li>
                  <li> Adaptive Signal Processing</li>
                  <li> Nano Electronics </li>
                  <li> Low Power Electronics</li>
                  <li> Robotics and Automation</li>
                  <li> VLSI for DSP</li>
                  <li> Nano-Fabrication & Computing</li>
                  <li> Semiconductor Technology</li>
                  <li> Filters and Data Conversion Circuits</li>
                  <li> Analog & Digital Circuits</li>
                  <li> Mixed Signal Circuits</li>
                  <li> ASIC & SOC</li>
                  <li> CAD for VLSI</li>
                  <li> Advanced VLSI Systems VLSI</li>
                  <li> Advanced VLSI Systems</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="about">
          <div
            className="card border-primary mb-3"
            style={{ width: "auto", height: "100%" }}
          >
            <div className="card-body">
              <h5 className="card-title text-primary">
                TRACK 2: NETWORKING TECHNOLOGIES
              </h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div className="container">
                <ol style={{ listStyle: "disc" }}>
                  <li>Information and Communication Technologies</li>
                  <li>Mobile and Optical Networks</li>
                  <li>Wireless Sensing and Sensor Networks</li>
                  <li>Social & Smart Networks</li>
                  <li>Software Defined Networks</li>
                  <li>Mobile Ad-hoc Networks</li>
                  <li>Vehicular Ad-hoc Networks</li>
                  <li>Cognitive Radio Networks</li>
                  <li>Intelligent Networking</li>
                  <li>Parallel and Distributed Networks</li>
                  <li>Network Visualization</li>
                  <li>Underwater Communication Networks</li>
                  <li>Future Internet and Next-Generation Networks</li>
                  <li>Body Area Networks</li>
                  <li>Internet Technology & Applications</li>
                  <li>Cyber-Physical Systems for Sustainable Computing</li>
                  <li>Mobile Computing and Communication</li>
                  <li>Smart City Technologies and Systems</li>
                  <li>Information and Data Processing</li>
                  <li>Artificial Intelligence and Neural Networks</li>
                  <li>Wired/Wireless Technology Integration</li>
                  <li>Digital Forensics</li>
                  <li>Internet of Things</li>
                  <li>Big Data and Data Mining</li>
                  <li>Green Pervasive Computing</li>
                  <li>Fuzzy, Neural and Evolutionary Computation</li>
                  <li>Network Security</li>
                  <li>Cryptography & Data Security</li>
                  <li>Smart Security Models and Applications</li>
                  <li>Internet Technology & Applications</li>
                  <li>Cyber Physical Systems for Sustainable Computing</li>
                  <li>Natural Language Processing</li>
                  <li>Human Computer Interaction</li>
                  <li>Remote sensing</li>
                  <li>Bio-medical applications</li>
                  <li>Virtual & e-Learning</li>
                  <li>AI & Machine Learning</li>
                  <li>Computational Intelligence</li>
                  <li>Big Data Analytics</li>
                  <li>Green Computing</li>
                  <li>Grid Computing</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
